const getBreadcrumb = (navi) => {
    const breadcrumb = [
        {
            text: 'backoffice.nav.DeveloperTool',
        },
        {
            text: 'backoffice.nav.Product',
        }
    ];
    breadcrumb.push(navi);
    return breadcrumb;
};
export const products = [
    {
        name: 'products',
        path: '/products',
        component: () => import(/* webpackChunkName: "Main" */ '../../views/products/Main.vue'),
        redirect: {
            name: 'roles',
        },
        children: [
            {
                path: '/feature/',
                name: 'feature',
                meta: {
                    permission: 'Service',
                    breadcrumb: getBreadcrumb({
                        text: 'backoffice.nav.product_function',
                        active: true,
                    }),
                    permisson: 'Service',
                },
                component: () => import(/* webpackChunkName: "permission" */ '@/views/products/ProductsFeature/ProductsFeature.vue'),
            },
            {
                name: 'products-roles',
                path: 'roles',
                component: () => import(/* webpackChunkName: "ProductsRolesManagement" */ '../../views/products/ProductsRolesManagement/ProductsRolesManagement.vue'),
                props: true,
                meta: {
                    keepAlive: false,
                    breadcrumb: getBreadcrumb({
                        text: 'backoffice.nav.ProductRole',
                        active: true,
                    }),
                    permission: 'ProductRolesGetList',
                },
            },
            {
                name: 'products-resource',
                path: 'resource',
                component: () => import(/* webpackChunkName: "ProductsResourceManagement" */ '../../views/products/ProductsResourceManagement/ProductsResourceManagement.vue'),
                props: true,
                meta: {
                    keepAlive: false,
                    breadcrumb: getBreadcrumb({
                        text: 'backoffice.nav.ProductResource',
                        active: true,
                    }),
                    permission: 'ResourcesGetList',
                },
            },
            {
                name: 'products-limitation',
                path: 'limitation',
                component: () => import(/* webpackChunkName: "ProductsResourceManagement" */ '../../views/products/ProductsRoleslimitation/ProductsRoleslimitation.vue'),
                props: true,
                meta: {
                    keepAlive: false,
                    breadcrumb: getBreadcrumb({
                        text: 'backoffice.nav.ProductRoleLimitation',
                        active: true,
                    }),
                    permission: 'ResourcesRoleLimitationGetList',
                },
            }
        ],
    }
];
